import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from '@mui/material';
import { FoundScanRow } from './Stage3JuryPairs.types';

type Props = {
	open: boolean;
	onClose: () => void;
	busy: boolean;
	previewIndex: number;
	totalCount: number;
	previewCurrentRow: FoundScanRow | null;
	previewHasPrev: boolean;
	previewHasNext: boolean;
	onPrev: () => void;
	onNext: () => void;
	onAutoScanOkAndNext: () => void;
};

const Stage3DrivePreviewDialog = ({
	open,
	onClose,
	busy,
	previewIndex,
	totalCount,
	previewCurrentRow,
	previewHasPrev,
	previewHasNext,
	onPrev,
	onNext,
	onAutoScanOkAndNext,
}: Props) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullScreen
		>
			<DialogTitle>
				Podgląd skanu ({previewIndex + 1 > 0 ? previewIndex + 1 : 0}/{totalCount}):{' '}
				{previewCurrentRow?.source_file_name || previewCurrentRow?.work_code || ''}
			</DialogTitle>
			<DialogContent>
				{previewCurrentRow?.source_file_id ? (
					<Box sx={{ height: 'calc(100vh - 170px)' }}>
						<iframe
							title='Podglad skanu Google Drive'
							src={`https://drive.google.com/file/d/${previewCurrentRow.source_file_id}/preview`}
							style={{ width: '100%', height: '100%', border: 0 }}
						/>
					</Box>
				) : (
					<Typography variant='body2'>Brak podglądu inline dla wybranego pliku.</Typography>
				)}
				<Typography
					variant='caption'
					sx={{ display: 'block', mt: 1 }}
				>
					PoC: podgląd korzysta z renderingu Google Drive. Komentarze są widoczne zależnie od uprawnień i widoku Google.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={onPrev}
					disabled={!previewHasPrev || busy}
				>
					Poprzedni
				</Button>
				<Button
					onClick={onNext}
					disabled={!previewHasNext || busy}
				>
					Następny
				</Button>
				<Button
					variant='contained'
					onClick={onAutoScanOkAndNext}
					disabled={busy || previewCurrentRow?.existing_status !== 'AUTO-SKAN'}
				>
					AUTOSKANOK i dalej
				</Button>
				{previewCurrentRow?.drive_view_url ? (
					<Button
						href={previewCurrentRow.drive_view_url}
						target='_blank'
						rel='noopener noreferrer'
					>
						Otwórz dokument w nowej karcie
					</Button>
				) : null}
				<Button onClick={onClose}>Zamknij</Button>
			</DialogActions>
		</Dialog>
	);
};

export default Stage3DrivePreviewDialog;
